/** Admin / configuration API query segments */
export const AdminQueryKeys = {
  publicHolidayCalendars: {
    all: ['admin/holiday-calendars'] as const,
    detail: (calendarUid: string) => ['admin/holiday-calendars', calendarUid] as const,
  },
  /** Consumer-facing holiday calendars list (assets domain) */
  holidayCalendars: {
    all: ['holiday-calendars'] as const,
  },
  taskTypes: {
    all: ['admin-task-types'] as const,
    detail: (uid: string) => ['admin-task-type', uid] as const,
    allowedTeams: (allowedTeams: unknown) => ['admin-allowed-teams', allowedTeams] as const,
  },
  taskPriorities: {
    all: ['task-priorities'] as const,
  },
  customFields: {
    all: ['custom-fields'] as const,
  },
  customDataGroups: {
    all: ['custom-data-groups'] as const,
  },
  extMetadataGroups: {
    all: ['admin/ext-metadata-groups'] as const,
    detail: (uid: string) => [`admin/ext-metadata-groups/${uid}`] as const,
  },
  extMetadataAttributes: {
    all: ['admin/ext-metadata-attributes'] as const,
    detail: (attributeUid: string) => ['admin/ext-metadata-attributes', attributeUid] as const,
  },
  serviceLevels: {
    all: ['service-levels'] as const,
    detail: (uid: string) => ['service-level', uid] as const,
    pathAll: () => [{ path: 'service-levels' }] as const,
  },
  companyBrand: {
    all: ['company-brand'] as const,
  },
  offerings: {
    all: ['fetch-offerings'] as const,
    pathAll: () => [{ path: 'offerings' }] as const,
  },
  productCatalogues: {
    search: (search: unknown) => ['product-catalogues-search', search] as const,
    detail: (uid: string) => ['fetch-product-catalogue', uid] as const,
    pathDetail: (uid: string) => [{ path: `product-catalogues/${uid}` }] as const,
    pathResolvedDetail: (uid: string) => [{ path: `product-catalogues-resolved/${uid}` }] as const,
  },
  products: {
    detail: (uid: string) => ['fetch-product', uid] as const,
    search: (search: unknown) => ['products-search', search] as const,
    filterValues: {
      all: ['product-filter-values'] as const,
    },
  },
  productTypes: {
    all: ['product-type'] as const,
    detail: (productTypeUid: string) => ['product-type', productTypeUid] as const,
    pathAll: () => [{ path: 'product-types' }] as const,
    pathDetail: (uid: string) => [{ path: `product-types/${uid}` }] as const,
  },
};
